const Message = {
  // Http error messages
  ERROR_MESSAGE_400:
    "The server is unable to process your request due to invalid syntax. Please contact to your administrator",
  ERROR_MESSAGE_401: "Your session has timed out. Please login to continue",
  ERROR_MESSAGE_403:
    "You do not have the permission to view this page. Please contact to your administrator",
  ERROR_MESSAGE_404:
    "The Web server cannot find page you asked for. Please check the URL ensure that the path is correct",
  ERROR_MESSAGE_410:
    "You are no longer associated with OneTeam360 admin portal",
  ERROR_MESSAGE_500:
    "The server encountered an internal error and was unable to complete your request. Please contact to your administrator",
  ERROR_MESSAGE_0:
    "An error occurred while processing your request. Please contact to your administrator",
  MSG_INSUFFICIENT_LOGIN_RIGHTS:
    "User is not registered with application, please contact your Administrator",
  MESSAGE_API_ERROR:
    "Error processing the request, please contact your Administrator",
  ERROR_PAGE_URL: "/error/401",
  PAGE_NOT_FOUND: "/error/404",
  UN_AUTHORIZED_TOKEN: "Unauthorized token.",

  // Validation messages
  VAL_MIN_LENGTH: "{0} must contain at least {1} character(s)",
  VAL_MAX_LENGTH: "{0} cannot exceed than {1} characters",
  VAL_REQUIRED: "{0} is required",
  VAL_INVALID: "{0} is invalid",
  IMAGE_TYPE_INVALID: "Invalid file type, allowed file types: jpg, png",
  IMAGE_SIZE_INVALID:
    "Invalid file size, file size should be smaller than 5 MB",

  // Input control variable
  VAL_PASSWORD:
    "Use minimum 8 characters with a mix of letters(at least one char in Caps & Lower), numbers & symbols.",
  VAL_PASSWORD_MATCH: "Please match the requested format.",
  MSG_SENT_SUCCESS: "{0} sent successfully",
  VAL_MIN_LENGTH_CHARACTER: "{0} must contain at least {1} character(s)",
  VAL_MAX_LENGTH_CHARACTER: "{0} cannot exceed than {1} characters",
  VAL_PASSWORD_NOT_MATCH: "Password and Confirm Password do not match",
  MSG_MAX_SIZE_VALIDATION:
    "Oops, the size of the images {0} exceeds the 3 MB file size and cannot be uploaded. Kindly upload a file with size less than 3 MB.",

  MSG_IMAGE_TYPE_VALIDATION: "Invalid file type, allowed file types: {0}",
  MSG_FILE_SIZE: "Invalid file size, file size should be smaller than {0}",
  MSG_SELECT_FILE: "Please upload at least one image to proceed.",

  VAL_FIRST_NAME_REQUIRED: "First Name is Required",
  VAL_FIRST_MIN_LENGTH_CHARACTER:
    "First Name must contain at least {1} character(s)",
  VAL_LAST_NAME_REQUIRED: "Last Name is Required",
  VAL_LAST_MIN_LENGTH_CHARACTER:
    "Last Name must contain at least {1} character(s)",
  VAL_EMAIL_REQUIRED: "Email is Required",
  VAL_EMAIL_VALID: "Email must Valid",
  VAL_PASSWORD_REQUIRED: "Password is Required",

  VAL_LOCATION_MIN_LENGTH_CHARACTER:
    "Location must contain at least {1} character(s)",
  VAL_LOCATION_REQUIRED: "Location is Required",

  VAL_DIPARTMENT_REQUIRED: "Department is Required",
  VAL_ROLE_REQUIRED: "Role is Required",
  VAL_LEVEL_REQUIRED: "Level is Required",

  VAL_RELAITIVE_REQUIRED: "Relative Name is Required",
  VAL_RELAITIVE_MIN_LENGTH_CHARACTER:
    "Relative must contain at least {1} character(s)",

  VAL_RELAITIVE_ADDRESS_REQUIRED: "Relative Address is Required",
  VAL_RELAITIVE_ADDRESS_MIN_LENGTH_CHARACTER:
    "Relative Address must contain at least {1} character(s)",

  VAL_RELATION_REQUIRED: "Relation is Required",
  VAL_RELATION_MIN_LENGTH_CHARACTER:
    "Relation must contain at least {1} character(s)",
  VAL_IMAGE_REQUIRED: "Image is Required",

  // Toasts messages
  MSG_MODEL_INVALID: "Invalid model",
  MSG_ADD_SUCCESS: "{0} added successfully",
  MSG_EDIT_SUCCESS: "{0} edited  successfully",
  MSG_SAVE_SUCCESS: "{0} saved successfully",
  MSG_COPY_SUCCESS: "{0} copied successfully",
  MSG_CREATE_SUCCESS: "{0} created successfully",
  MSG_UPDATE_SUCCESS: "{0} updated successfully",
  MSG_DELETE_SUCCESS: "{0} deleted successfully",
  MSG_VOID_SUCCESS: "{0} voided successfully",
  MSG_UNCOVER_SUCCESS: "{0} uncovered successfully",
  MSG_ALREADY_EXISTS: "{0} already exists",
  MSG_UPLOADED_SUCCESS: "{0} uploaded successfully",
  MSG_APPLIED_SUCCESS: "{0} applied successfully",
  MSG_SUCCESS: "{0} successfully",
  MSG_FORGET_USER_NAME_EMAIL:
    "Email Sent! Please check your email for your username.",
  DEFAULT_SELECT_LABEL: "Please Select",
};

export default Message;
